import { useRef, useState } from "react";
import { PlacesType, Tooltip } from "react-tooltip";

import "./styles.scss";

export default function TooltipWrapper({ place, value, className = "" }: { place: PlacesType; value: any; className?: string }): JSX.Element {
	const [displayTooltip, setDisplayTooltip] = useState(false);
	const valueRef = useRef<HTMLDivElement>(null);

	const handleDisplayTooltip = () => {
		if (valueRef.current) {
			const overflow = valueRef.current.scrollWidth > valueRef.current.clientWidth;

			setDisplayTooltip(overflow);
		}
	};

	return (
		<div onMouseEnter={handleDisplayTooltip} onMouseLeave={() => setDisplayTooltip(false)}>
			<div className={`overflow-element ${className}`} id="tooltip" ref={valueRef}>
				{value}
			</div>
			<Tooltip anchorSelect="#tooltip" hidden={!displayTooltip} place={place} className="z-10">
				{value}
			</Tooltip>
		</div>
	);
}
